import { render, staticRenderFns } from "./ListUserTopPoints.vue?vue&type=template&id=367b7953&"
import script from "./ListUserTopPoints.vue?vue&type=script&lang=js&"
export * from "./ListUserTopPoints.vue?vue&type=script&lang=js&"
import style0 from "./ListUserTopPoints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
